import React from 'react';
import CreditCardModal from 'app/components/Subscription/CreditCardModal.jsx';
import Loading from 'app/components/common/Loading.jsx';
import GetPlanData from 'app/utility/GetPlanData.js';
import ErrorBoundary from 'app/components/common/ErrorBoundary.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import ComponentWithRouter from 'app/components/Routers/ComponentWithRouter.jsx';
import UserMessages from 'app/modules/UserMessageModule.js';
import SubscriptionFeatureBlock from 'app/components/Subscription/SubscriptionFeatureBlock.jsx';
import AnnualDiscount from 'app/components/Promos/AnnualDiscount.jsx';
import FreeToAnnual from 'app/components/Promos/FreeToAnnual.jsx';
import MonthlyToAnnual from 'app/components/Promos/MonthlyToAnnual.jsx';
import PromoDefault from 'app/components/Promos/PromoDefault.jsx';
import MinimalModal from 'app/components/Modals/MinimalModal.jsx';
import * as _ from 'underscore';
import { compose } from 'redux';
import makeToast from 'app/modules/makeToast.js';

class PromoLanding extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            promoActive: true,
            otherError: false,
            activePromos: {
                1: {
                    2: {
                        price: 99,
                        addOnPrice: 99,
                        duration: 12,
                        planLevel: 6,
                        planTerm: 2,
                        description: 'Annual Upgrade - Promotional Pricing',
                        couponCode: 'BIGDEAL', // prod
                        //couponCode: 'march_fixed', // dev
                        element: FreeToAnnual,
                        newSub: true
                    }
                },
                2: {
                    1: {
                        price: 99,
                        addOnPrice: 99,
                        duration: 12,
                        planLevel: 2,
                        planTerm: 2,
                        description: 'Annual Upgrade - Promotional Pricing',
                        couponCode: 'BIGDEAL', // prod
                        //couponCode: 'march_percent', // dev
                        element: MonthlyToAnnual,
                        newSub: false
                    },
                    2: {
                        price: 99,
                        addOnPrice: 99,
                        tweetPrice: 30,
                        duration: 12,
                        description: 'Annual Renewal - Promotional Pricing',
                        promoCode: 'promo_06_2026.1',
                        element: AnnualDiscount,
                        newSub: false
                    }
                },
                6: {
                    1: {
                        price: 99,
                        addOnPrice: 99,
                        duration: 12,
                        planLevel: 6,
                        planTerm: 2,
                        description: 'Annual Upgrade - Promotional Pricing',
                        couponCode: 'EXTEND99', // production
                        //couponCode: 'march_percent', // dev
                        element: MonthlyToAnnual,
                        newSub: false
                    },
                    2: {
                        price: 99,
                        addOnPrice: 99,
                        tweetPrice: 30,
                        duration: 12,
                        description: 'Annual Renewal - Promotional Pricing',
                        promoCode: 'promo_06_2026.1',
                        element: AnnualDiscount,
                        newSub: false
                    }
                },
                9: {
                    1: {
                        price: 279,
                        addOnPrice: 99,
                        tweetPrice: 23,
                        duration: 12,
                        planLevel: 9,
                        planTerm: 2,
                        description: 'Annual Upgrade - Promotional Pricing',
                        //couponCode: '25plus', // production
                        couponCode: 'march_2025_plus_percent', // dev
                        element: MonthlyToAnnual,
                        newSub: false
                    },
                    2: {
                        price: 279,
                        addOnPrice: 99,
                        tweetPrice: 30,
                        duration: 12,
                        description: 'Annual Renewal - Promotional Pricing',
                        promoCode: 'promo_06_2026.1',
                        element: AnnualDiscount,
                        newSub: false
                    }
                },
                15: {
                    1: {
                        price: 99,
                        addOnPrice: 99,
                        duration: 12,
                        planLevel: 6,
                        planTerm: 2,
                        description: 'Annual Upgrade - Promotional Pricing',
                        couponCode: 'BIGDEAL', // production
                        //couponCode: 'march_percent', // dev
                        element: FreeToAnnual,
                        newSub: true
                    },
                    2: {
                        price: 99,
                        addOnPrice: 99,
                        planLevel: 6,
                        planTerm: 2,
                        duration: 12,
                        description: 'Annual Renewal - Promotional Pricing',
                        couponCode: 'BIGDEAL', // prod
                        //couponCode: 'march_fixed', // dev
                        element: FreeToAnnual,
                        newSub: true
                    }
                },
                16: {
                    1: {
                        price: 99,
                        addOnPrice: 99,
                        duration: 12,
                        planLevel: 6,
                        planTerm: 2,
                        description: 'Annual Upgrade - Promotional Pricing',
                        couponCode: 'BIGDEAL', // production
                        //couponCode: 'march_percent', // dev
                        element: FreeToAnnual,
                        newSub: true
                    },
                    2: {
                        price: 99,
                        addOnPrice: 99,
                        planLevel: 6,
                        planTerm: 2,
                        duration: 12,
                        description: 'Annual Renewal - Promotional Pricing',
                        couponCode: 'BIGDEAL', // prod
                        //couponCode: 'march_fixed', // dev
                        element: FreeToAnnual,
                        newSub: true
                    }
                },
                17: {
                    1: {
                        price: 99,
                        addOnPrice: 99,
                        duration: 12,
                        planLevel: 6,
                        planTerm: 2,
                        description: 'Annual Upgrade - Promotional Pricing',
                        couponCode: 'BIGDEAL', // production
                        //couponCode: 'march_percent', // dev
                        element: FreeToAnnual,
                        newSub: true
                    },
                    2: {
                        price: 99,
                        addOnPrice: 99,
                        planLevel: 6,
                        planTerm: 2,
                        duration: 12,
                        description: 'Annual Renewal - Promotional Pricing',
                        couponCode: 'BIGDEAL', // prod
                        //couponCode: 'march_fixed', // dev
                        element: FreeToAnnual,
                        newSub: true
                    }
                }
            },
            loading: {
                subscription: true,
                promoValidation: true
            },
            redeemed: false,
            isWorking: false
        };

        this.getPromoForPlan = this.getPromoForPlan.bind(this);
        this.onRedeemPromoClick = this.onRedeemPromoClick.bind(this);
        this.getCurrentAddOns = this.getCurrentAddOns.bind(this);
        this.getCurrentTweets = this.getCurrentTweets.bind(this);

    }


    componentDidMount() {

        this.props.getSubscription();
        this.props.getPlans();

    }

    componentDidUpdate(prevProps, prevState) {
        let nextLoading = Object.assign({}, this.state.loading),
            errors = [];

        if (prevProps && prevProps.app.loading.SUB_FETCH === true && this.props.app.loading.SUB_FETCH === false) {
            if (nextLoading.subscription) {
                nextLoading.subscription = false;
            }

            if (this.props.user.detail.pubLevel > 1) {
                // get info for the cc modal should it be needed
                this.props.getBillingInfo();
            }

            let promo = this.getPromoForPlan();
            if (promo !== null && !this.state.redeemed) {
                if (promo.couponCode !== undefined) {
                    this.props.validatePromo({
                        couponCode: promo.couponCode
                    });
                } else {
                    this.props.validatePromo({
                        promoCode: promo.promoCode
                    });
                }
            }

        }

        if (prevProps && prevProps.app.loading.SUB_VALIDATE_PROMO === true && this.props.app.loading.SUB_VALIDATE_PROMO === false) {
            errors = this.props.getApiErrors(['SUB_VALIDATE_PROMO']);
            if (errors.length && errors[0].errors.validation !== undefined) {
                // user doesn't have a subscription to check against, it's ok
                this.props.deleteApiError(['SUB_VALIDATE_PROMO']);
            }

            if (nextLoading.promoValidation) {
                nextLoading.promoValidation = false;
            }

        }

        if (prevProps.app.loading.SUB_UPDATE_BILLING === true && this.props.app.loading.SUB_UPDATE_BILLING === false) {
            errors = this.props.getApiErrors(['SUB_UPDATE_BILLING']);
            if (!errors.length) {
                let promo = this.getPromoForPlan();
                // We've got good payment info! Great!
                // If a promoCode is in play the invoice will charge automatically and they're GTG
                // If a couponCode is the way, we need to resubmit the subscription change
                if (promo.promoCode !== undefined) {
                    this.props.closeAllModals();
                    makeToast("Promo applied", "success");
                    this.props.router.navigate("/share/automate");
                } else if (promo.couponCode !== undefined) {
                    this.props.closeAllModals();
                    this.setState({
                        isWorking: false
                    }, () => {
                        this.onRedeemPromoClick();
                    });
                }
            }
        }

        if (prevProps && prevProps.app.loading.SUB_REDEEM_PROMO === true && this.props.app.loading.SUB_REDEEM_PROMO === false) {
            let errors = this.props.getApiErrors(['SUB_REDEEM_PROMO']);
            if (errors.length) {
                let error = errors[0];
                if (error.errors.recurly !== undefined &&
                    (error.errors.recurly.error.match(/invoice failed/i) ||
                     error.errors.recurly.error.match(/The transaction was declined/i))) {
                    let ccModal = null,
                        first = '',
                        last = '',
                        parts = [];

                    if (this.props.plans.billingInfo.firstName !== undefined && this.props.plans.billingInfo.firstName &&
                        this.props.plans.billingInfo.lastName !== undefined && this.props.plans.billingInfo.lastName) {
                        first = this.props.plans.billingInfo.firstName;
                        last = this.props.plans.billingInfo.lastName;
                    } else {
                        parts = this.props.user.detail.username.split("@");
                        first = parts[0];
                        last = parts[1];
                    }

                    makeToast("", "error", {
                        title: "Payment failed",
                        description: "Update billing info to get promo",
                        action: {
                            label: 'Update',
                            onClick: () => { this.props.router.navigate("/account/billing")}
                        }
                    });

                    this.props.addModal(
                        <CreditCardModal
                            {...this.props}
                            plan={this.props.user.detail.pubLevel}
                            planTerm={this.props.plans.current.planTerm}
                            planPrice={this.props.plans.current.price}
                            firstName={first}
                            lastName={last}
                            router={this.props.router}
                            closeAction={() => {
                                this.setState({
                                    isWorking: false
                                });
                                this.props.closeAllModals();
                            }}
                            action='update'
                            heading={"Update your Payment Info"}
                            version={1} />
                    );
                } else {
                    this.setState({
                        isWorking: false,
                        otherError: true
                    })
                }
                this.props.deleteApiError(['SUB_REDEEM_PROMO']);
            } else {
                // grab the updated subscription info for
                // the confirmation screen
                this.props.getUser();
                this.props.getUserPerms();
                this.props.getSubscription();
                nextLoading.subscription = true;
                this.setState({
                    redeemed: true
                });
            }
        }

        if (!_.isEqual(this.state.loading, nextLoading)) {
            this.setState({
                loading: nextLoading,
                isWorking: false
            });
        }

    }

    getPromoForPlan() {
        let promo = null,
            level = 1,
            term = 2;

        if ([1, 17].indexOf(this.props.user.detail.pubLevel) === -1) {
            level = this.props.plans.current.planLevel,
            term = this.props.plans.current.planTerm;
        }

        promo = (this.state.activePromos[level] !== undefined && this.state.activePromos[level][term] !== undefined) ? this.state.activePromos[level][term] : null;

        return promo;

    };

    getCurrentAddOns() {
        if (this.props.user.detail.pubLevel <= 1) {
            return 0;
        }

        return (this.props.plans.current.addOns !== undefined && this.props.plans.current.addOns.add_on_social !== undefined) ? this.props.plans.current.addOns.add_on_social.qty : 0;
    }

    getCurrentTweets() {
        if (this.props.user.detail.pubLevel <= 1) {
            return 0;
        }

        return (this.props.plans.current.addOns !== undefined && this.props.plans.current.addOns.add_on_posts_1 !== undefined) ? this.props.plans.current.addOns.add_on_posts_1.qty : 0;
    }

    onRedeemPromoClick(e) {
        let promoData = {},
            addOnCount = 0,
            tweetCount = 0,
            promo = this.getPromoForPlan(),
            planDetail = GetPlanData.lookupDetails(this.props.plans.current.planLevel, this.props.plans.current.planTerm);

        if (this.state.isWorking) {
            return;
        }

        //const redeemPromo = () => {
            //this.props.closeAllModals();
            if (promo.promoCode !== undefined) {
                promoData.promoCode = promo.promoCode;
            }
            promoData.description = promo.description;
            promoData.duration = promo.duration;
            promoData.plan = planDetail.plan_id;

            if (promo.couponCode) {
                promoData.couponCode = promo.couponCode;
                promoData.planLevel = promo.planLevel;
                promoData.planTerm = promo.planTerm;

                this.props.redeemPromo(promoData);

                this.setState({
                    isWorking: true
                });

            } else {
                promoData.invoiceCharge = promo.price;

                addOnCount = this.getCurrentAddOns();
                if (addOnCount) {
                    promoData.invoiceCharge += (promo.addOnPrice * addOnCount);
                }

                tweetCount = this.getCurrentTweets();
                if (tweetCount) {
                    promoData.invoiceCharge += (promo.tweetPrice * tweetCount);
                }

                // don't send a 0 charge
                if (promoData.invoiceCharge) {
                    this.props.redeemPromo(promoData);
                    this.setState({
                        isWorking: true
                    });
                }

            }
        //}

        // this.props.addModal(
        //     <MinimalModal
        //         mode="confirmPromo"
        //         cancelAction={() => {
        //             this.props.closeAllModals();
        //         }}
        //         content={
        //             <div className="confirm-promo">
        //                 <div className="confirm-content">
        //                     Claim this deal and renew?
        //                 </div>
        //                 <div className="promo-action-button" role="button" onClick={redeemPromo}>
        //                     Yes, I want this deal!
        //                 </div>
        //             </div>
        //         }/>
        // );

    }

    render() {
        let promoContent = null,
            staticContent = null,
            imgPath = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            features = [
                {
                    image: `${imgPath}/promo-page/promo-21.svg`,
                    label: '20 Social Platforms',
                    description: <span>Auto post your content to all your social networks.</span>
                },
                {
                    image: `${imgPath}/promo-page/promo-reel.svg`,
                    label: 'Video Automation',
                    description: <span>Post videos from Instagram, YouTube, and TikTok.</span>
                },
                {
                    image: `${imgPath}/promo-page/promo-rocket.svg`,
                    label: 'Boost Reach',
                    description: <span>Engage your audience across all social platforms.</span>
                },
                {
                    image: `${imgPath}/promo-page/promo-clock.svg`,
                    label: 'Save Time',
                    description: <span>Share everywhere with zero extra effort.</span>
                },
            ],
            planData = GetPlanData.lookupDetails(this.props.plans.current.planLevel, this.props.plans.current.planTerm),
            defaultButtonLabel = "Get back to posting",
            staticBlock = null;


        const nothingToSeeHere = (e) => {
            e.preventDefault();

            this.props.router.navigate("/share/automate");

        }

        if (!this.state.promoActive) {
            promoContent = (
                <PromoDefault
                    main={"Sorry, there are no active promotions at the moment."}
                    buttonLabel={defaultButtonLabel}
                    buttonAction={nothingToSeeHere}/>
            );
        } else if (this.state.otherError) {
            promoContent = (
                <PromoDefault
                    main={"Sorry, there was an error activating that promo for you."}
                    buttonLabel={defaultButtonLabel}
                    buttonAction={nothingToSeeHere}
                    help={<span>Need help? <a href="mailto:support@dlvr.it">Contact us.</a></span>}/>
            );
        } else {
            if (this.state.loading.subscription || this.state.loading.promoValidation) {
                promoContent = (<Loading/>);
            } else if (this.state.loading.promoValidation === false && this.props.plans.promoRedeemed) {
                promoContent = (
                    <PromoDefault
                        main={"Looks like you've already claimed this promotion!"}
                        buttonLabel={defaultButtonLabel}
                        buttonAction={nothingToSeeHere}
                        help={<span>Need help? <a href="mailto:support@dlvr.it">Contact us.</a></span>}
                        action={nothingToSeeHere}/>
                );
            } else if (this.state.redeemed) {
                promoContent = (
                    <PromoDefault
                        image={<img src={`${imgPath}/promo-page/promo-burst-3.gif`} height="150px" width="auto"/>}
                        main={"Your plan change is confirmed"}
                        subCopy={<span>Your new {planData.plan_name} plan subscription will renew on {moment(this.props.user.plan.nextBilling).add(1, 'year').format("MMMM D, YYYY")}.</span>}
                        buttonLabel={defaultButtonLabel}
                        buttonAction={nothingToSeeHere}/>
                );
            } else {
                let planTotal = 0,
                    planAddOns = this.getCurrentAddOns(),
                    tweetAddOns = this.getCurrentTweets(),
                    promo = null,
                    promoClick = this.onRedeemPromoClick;


                promo = this.getPromoForPlan();

                if (promo.newSub) {
                    promoClick = (e) => {
                        this.props.router.navigate(`/account/subscription/new?code=${promo.couponCode}&term=2`);
                    }
                }

                if (!promo) {
                    promoContent = (
                        <PromoDefault
                            main={"Looks like you don't qualify for this promotion."}
                            buttonLabel={"Get back to posting"}
                            buttonAction={nothingToSeeHere}
                            help={<span>Need help? <a href="mailto:support@dlvr.it">Contact us.</a></span>}/>
                    );
                } else {
                    let Element = promo.element;

                    promoContent = (
                        <Element
                            {...this.props}
                            image={<img src={`${imgPath}/promo-page/promo-burst-3.gif`} height="150px" width="auto"/>}
                            promo={promo}
                            onRedeemPromoClick={this.onRedeemPromoClick}
                            features={features}
                            planAddOns={planAddOns}
                            planTweets={tweetAddOns}
                            isWorking={this.state.isWorking}/>
                    );

                    staticBlock = (
                        <div className="static-block">
                            <SubscriptionFeatureBlock {...this.props}/>
                            <div className="static-action">
                                <div className="promo-action-button" role="button" aria-label="Claim the deal"  onClick={promoClick}>
                                    {this.state.isWorking ? (
                                        <span>
                                            <i className="fa fa-spinner fa-spin"></i>
                                        </span>
                                    ) : 'Get our best price'}
                                </div>
                            </div>
                        </div>
                    );

                }

            }
        }

        return (
            <ErrorBoundary level="view" {...this.props}>
                <div>
                    <div className="promo-display">
                        <div className="subscription-content-block">
                            {promoContent}
                        </div>
                        {staticBlock}
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}

PromoLanding.displayName = "PromoLanding";

const enhance = compose(
    ComponentWithContext,
    ComponentWithRouter
);

export default enhance(PromoLanding);
